import type { SVGProps } from 'react';

export const ControlAdd = (props: SVGProps<any>) => (
  <svg
    height="32px"
    role="img"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'control add'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <rect height="32" width="32" x="0" y="0" />
      <g fill={props.fill}>
        <path d="M16.8472,15.2472 L16.8472,8.7 L15.2472,8.7 L15.2472,15.2472 L8.7,15.2472 L8.7,16.8472 L15.2472,16.8472 L15.2472,23.3976 L16.8472,23.3976 L16.8472,16.8472 L23.3944,16.8472 L23.3944,15.2472 L16.8472,15.2472 L16.8472,15.2472 Z M16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 Z M16,1.6 C8.0470996,1.6 1.6,8.0470996 1.6,16 C1.6,23.9529004 8.0470996,30.4 16,30.4 C23.9529004,30.4 30.4,23.9529004 30.4,16 C30.4,8.0470996 23.9529004,1.6 16,1.6 Z" />
      </g>
    </g>
  </svg>
);
